import * as Models from 'contracts/models';

export const Endpoint = (taskId: string) => `/vscanner/api/v2/projects/state/${taskId}`;

export const QueryKey = (taskId: string) => ['vscanner', 'api', 'v2', 'projects', 'state', taskId] as const;

export type Payload = Record<string, never>;

export type Response = Models.Vscanner.ProjectTaskState | null;
